const firebaseConfig = {
    apiKey: "AIzaSyBGvETXSfZMzVZQe6oS-Yhl0hZay3TEFQ0",
    authDomain: "dhakametrorail.firebaseapp.com",
    projectId: "dhakametrorail",
    storageBucket: "dhakametrorail.appspot.com",
    messagingSenderId: "696929173882",
    appId: "1:696929173882:web:9e9ee9a69683d39f05d6c3"
};
export default firebaseConfig;